// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/antd/dist/reset.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 导入 Ant Design 样式 */

/* 导入Inter字体 */

/* CSS变量定义 - 与新UI设计保持一致 */
:root {
  --color-primary: #6C5CE7;
  --color-secondary: #FD79A8;
  --color-accent: #00B894;
  --color-dark: #2D3436;
  --color-light: #F8F9FA;
  --color-text: #2D3436;
  --color-text-secondary: #636e72;
  --color-text-light: #ddd;
  --color-bg: #F8F9FA;
  --color-bg-white: #ffffff;
  --border-radius: 12px;
  --border-radius-lg: 16px;
  --border-radius-full: 9999px;
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.06);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.08);
  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.12);
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

body {
  margin: 0;
  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--color-bg);
  color: var(--color-text);
  line-height: 1.6;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* 现代化全局样式 */
* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 隐藏滚动条但保持功能 */
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* 链接样式 */
a {
  color: var(--color-primary);
  text-decoration: none;
  transition: var(--transition);
}

a:hover {
  color: var(--color-secondary);
}

/* 选择文本样式 */
::selection {
  background: var(--color-primary);
  color: #fff;
}

::-moz-selection {
  background: var(--color-primary);
  color: #fff;
}

/* 通用动画类 */
.fade-in {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hover-lift {
  transition: var(--transition);
}

.hover-lift:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

/* 渐变文字效果 */
.gradient-text {
  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* 现代化按钮样式 */
.btn-modern {
  border-radius: var(--border-radius);
  font-weight: 500;
  transition: var(--transition);
  border: none;
  cursor: pointer;
}

.btn-modern:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

/* 页面过渡动画 */
.page-enter {
  opacity: 0;
  transform: translateY(20px);
}

.page-enter-active {
  opacity: 1;
  transform: translateY(0);
  transition: opacity 300ms ease-out, transform 300ms ease-out;
}

.page-exit {
  opacity: 1;
  transform: translateY(0);
}

.page-exit-active {
  opacity: 0;
  transform: translateY(-20px);
  transition: opacity 300ms ease-in, transform 300ms ease-in;
}

/* 卡片进入动画 */
.card-enter {
  opacity: 0;
  transform: scale(0.95) translateY(10px);
}

.card-enter-active {
  opacity: 1;
  transform: scale(1) translateY(0);
  transition: all 300ms ease-out;
}

/* 列表项动画 */
.list-item-enter {
  opacity: 0;
  transform: translateX(-20px);
}

.list-item-enter-active {
  opacity: 1;
  transform: translateX(0);
  transition: all 200ms ease-out;
}

/* 脉冲动画 */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* 骨架屏动画 */
@keyframes shimmer {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
}

.skeleton {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200px 100%;
  animation: shimmer 1.5s infinite;
}

/* 弹跳动画 */
@keyframes bounce {
  0%, 20%, 53%, 80%, 100% {
    transform: translate3d(0, 0, 0);
  }
  40%, 43% {
    transform: translate3d(0, -8px, 0);
  }
  70% {
    transform: translate3d(0, -4px, 0);
  }
  90% {
    transform: translate3d(0, -2px, 0);
  }
}

.bounce {
  animation: bounce 1s ease-in-out;
}

/* 摇摆动画 */
@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translateX(-2px);
  }
  20%, 40%, 60%, 80% {
    transform: translateX(2px);
  }
}

.shake {
  animation: shake 0.5s ease-in-out;
}

/* 加载状态样式 */
.loading-state {
  pointer-events: none;
  opacity: 0.6;
  position: relative;
}

.loading-state::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  margin: -10px 0 0 -10px;
  border: 2px solid transparent;
  border-top-color: var(--color-primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAGrB,cAAc;;AAGd,yBAAyB;AACzB;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,+BAA+B;EAC/B,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,4BAA4B;EAC5B,0CAA0C;EAC1C,2CAA2C;EAC3C,2CAA2C;EAC3C,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;EACjC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;;AAEA,YAAY;AACZ;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA,SAAS;AACT;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA,UAAU;AACV;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,WAAW;AACX;EACE,iFAAiF;EACjF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,mCAAmC;EACnC,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,WAAW;AACX;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,4DAA4D;AAC9D;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,0DAA0D;AAC5D;;AAEA,WAAW;AACX;EACE,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA,UAAU;AACV;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,SAAS;AACT;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,yDAAyD;AAC3D;;AAEA,UAAU;AACV;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,yEAAyE;EACzE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE;IACE,+BAA+B;EACjC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,sCAAsC;EACtC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* 导入 Ant Design 样式 */\n@import '~antd/dist/reset.css';\n\n/* 导入Inter字体 */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n/* CSS变量定义 - 与新UI设计保持一致 */\n:root {\n  --color-primary: #6C5CE7;\n  --color-secondary: #FD79A8;\n  --color-accent: #00B894;\n  --color-dark: #2D3436;\n  --color-light: #F8F9FA;\n  --color-text: #2D3436;\n  --color-text-secondary: #636e72;\n  --color-text-light: #ddd;\n  --color-bg: #F8F9FA;\n  --color-bg-white: #ffffff;\n  --border-radius: 12px;\n  --border-radius-lg: 16px;\n  --border-radius-full: 9999px;\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.06);\n  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.08);\n  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.12);\n  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\nbody {\n  margin: 0;\n  font-family: 'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--color-bg);\n  color: var(--color-text);\n  line-height: 1.6;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* 现代化全局样式 */\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* 滚动条样式 */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* 隐藏滚动条但保持功能 */\n.scrollbar-hide {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.scrollbar-hide::-webkit-scrollbar {\n  display: none;\n}\n\n/* 链接样式 */\na {\n  color: var(--color-primary);\n  text-decoration: none;\n  transition: var(--transition);\n}\n\na:hover {\n  color: var(--color-secondary);\n}\n\n/* 选择文本样式 */\n::selection {\n  background: var(--color-primary);\n  color: #fff;\n}\n\n::-moz-selection {\n  background: var(--color-primary);\n  color: #fff;\n}\n\n/* 通用动画类 */\n.fade-in {\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.hover-lift {\n  transition: var(--transition);\n}\n\n.hover-lift:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n/* 渐变文字效果 */\n.gradient-text {\n  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* 现代化按钮样式 */\n.btn-modern {\n  border-radius: var(--border-radius);\n  font-weight: 500;\n  transition: var(--transition);\n  border: none;\n  cursor: pointer;\n}\n\n.btn-modern:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n/* 页面过渡动画 */\n.page-enter {\n  opacity: 0;\n  transform: translateY(20px);\n}\n\n.page-enter-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity 300ms ease-out, transform 300ms ease-out;\n}\n\n.page-exit {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.page-exit-active {\n  opacity: 0;\n  transform: translateY(-20px);\n  transition: opacity 300ms ease-in, transform 300ms ease-in;\n}\n\n/* 卡片进入动画 */\n.card-enter {\n  opacity: 0;\n  transform: scale(0.95) translateY(10px);\n}\n\n.card-enter-active {\n  opacity: 1;\n  transform: scale(1) translateY(0);\n  transition: all 300ms ease-out;\n}\n\n/* 列表项动画 */\n.list-item-enter {\n  opacity: 0;\n  transform: translateX(-20px);\n}\n\n.list-item-enter-active {\n  opacity: 1;\n  transform: translateX(0);\n  transition: all 200ms ease-out;\n}\n\n/* 脉冲动画 */\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n/* 骨架屏动画 */\n@keyframes shimmer {\n  0% {\n    background-position: -200px 0;\n  }\n  100% {\n    background-position: calc(200px + 100%) 0;\n  }\n}\n\n.skeleton {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200px 100%;\n  animation: shimmer 1.5s infinite;\n}\n\n/* 弹跳动画 */\n@keyframes bounce {\n  0%, 20%, 53%, 80%, 100% {\n    transform: translate3d(0, 0, 0);\n  }\n  40%, 43% {\n    transform: translate3d(0, -8px, 0);\n  }\n  70% {\n    transform: translate3d(0, -4px, 0);\n  }\n  90% {\n    transform: translate3d(0, -2px, 0);\n  }\n}\n\n.bounce {\n  animation: bounce 1s ease-in-out;\n}\n\n/* 摇摆动画 */\n@keyframes shake {\n  0%, 100% {\n    transform: translateX(0);\n  }\n  10%, 30%, 50%, 70%, 90% {\n    transform: translateX(-2px);\n  }\n  20%, 40%, 60%, 80% {\n    transform: translateX(2px);\n  }\n}\n\n.shake {\n  animation: shake 0.5s ease-in-out;\n}\n\n/* 加载状态样式 */\n.loading-state {\n  pointer-events: none;\n  opacity: 0.6;\n  position: relative;\n}\n\n.loading-state::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 20px;\n  height: 20px;\n  margin: -10px 0 0 -10px;\n  border: 2px solid transparent;\n  border-top-color: var(--color-primary);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
